import axios from "axios";

/**
 * @description calls the project's own backend ReferenceDataApi controller
 * (com.zti.dedeElearning.api.ReferenceDataApi), which proxies dede-references
 * data (regions/provinces/districts/sub-districts/prenames) and caches it in MongoDB.
 */
class ReferenceDataApi {
  public static getRegions(regionCode?: string) {
    return axios.get(process.env.VUE_APP_API_URL + "/getReferenceRegions", {
      params: regionCode ? { regionCode } : {},
    });
  }

  public static getProvinces(provinceCode?: string) {
    return axios.get(process.env.VUE_APP_API_URL + "/getReferenceProvinces", {
      params: provinceCode ? { provinceCode } : {},
    });
  }

  public static getDistricts(provinceCode: string, districtCode?: string) {
    return axios.get(process.env.VUE_APP_API_URL + "/getReferenceDistricts", {
      params: districtCode
        ? { provinceCode, districtCode }
        : { provinceCode },
    });
  }

  public static getSubDistricts(
    provinceCode: string,
    districtCode: string,
    subDistrictCode?: string,
  ) {
    return axios.get(
      process.env.VUE_APP_API_URL + "/getReferenceSubDistricts",
      {
        params: subDistrictCode
          ? { provinceCode, districtCode, subDistrictCode }
          : { provinceCode, districtCode },
      },
    );
  }

  public static getPrenames(code?: string) {
    return axios.get(process.env.VUE_APP_API_URL + "/getReferencePrenames", {
      params: code ? { code } : {},
    });
  }
}

export default ReferenceDataApi;
